import React, { useState, useEffect, useContext } from "react";
import { Box, Typography, Grid, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";
import { CreatorContext } from "../../context/CreatorContext";
import { ArrowForwardIosOutlined } from "@mui/icons-material";
import Product1 from "../../assets/product1.png";
import Product2 from "../../assets/product2.png";
import Product3 from "../../assets/product3.png";
import Product4 from "../../assets/product4.png";
import Product5 from "../../assets/product5.png";
import Product6 from "../../assets/product6.png";
import Product7 from "../../assets/product7.png";
import Product8 from "../../assets/product8.png";
import Product9 from "../../assets/product9.png";
import Product10 from "../../assets/product10.png";
import Product11 from "../../assets/product11.png";
import Product12 from "../../assets/product12.png";

import ProductRestaurant1 from "../../assets/showcases/restaurant/product1.JPG";
import ProductRestaurant2 from "../../assets/showcases/restaurant/product2.JPG";
import ProductRestaurant3 from "../../assets/showcases/restaurant/product3.JPG";
import ProductRestaurant4 from "../../assets/showcases/restaurant/product4.JPG";
import ProductRestaurant5 from "../../assets/showcases/restaurant/product5.JPG";
import ProductRestaurant6 from "../../assets/showcases/restaurant/product6.JPG";
const ShowcaseOrders = ({ sector, order }) => {
	const { t } = useTranslation();
	const [orders, setOrders] = useState([]);
	const { creator } = useContext(CreatorContext);

	console.log(order);
	useEffect(() => {
		const loadOrders = () => {
			if (sector === "ecommerce") {
				return [
					{
						id: "#1667132936271",
						total: "€47.48",
						productsCount: 2,
						date: "30 Oct 22",
						status: t("orders.inProgress"),
						image: Product4,
					},
					{
						id: "#1667233207282",
						total: "€25.49",
						productsCount: 1,
						date: "31 Oct 22",
						status: t("orders.inProgress"),
						image: Product2,
					},
				];
			} else if (sector === "restaurant") {
				return [
					{
						id: "#1667132936271",
						total: "€30.00",
						productsCount: 3,
						date: "30 Oct 22",
						status: t("orders.completed"),
						image: ProductRestaurant3,
					},
					{
						id: "#1667233207282",
						total: "€15.50",
						productsCount: 1,
						date: "31 Oct 22",
						status: t("orders.pending"),
						image: ProductRestaurant2,
					},
				];
			} else {
				return [];
			}
		};

		setOrders(loadOrders());
	}, [sector, t]);

	return (
		<Box sx={{ padding: 1 }}>
			<Grid container spacing={1}>
				{order.value === "order1" &&
					orders.map((order, index) => (
						<Grid item xs={12} key={index}>
							<Box
								sx={{
									display: "flex",
									justifyContent: "space-between",
									alignItems: "flex-start",
								}}
							>
								<Box sx={{ display: "flex", gap: 1 }}>
									<img
										src={order.image}
										alt={order.title}
										style={{ width: 50, height: 50, objectFit: "cover" }}
									/>
									<Box>
										<Typography
											variant="body1"
											sx={{ fontWeight: "bold", fontSize: "8px" }}
										>
											{order.id}
										</Typography>
										<Typography variant="body2" sx={{ fontSize: "8px" }}>
											{order.total} |{" "}
											<span style={{ opacity: 0.6 }}>
												{order.productsCount} {t("orders.products")}
											</span>
										</Typography>
										<Typography variant="body2" sx={{ fontSize: "8px" }}>
											{order.date}
										</Typography>
										<Typography variant="body2" sx={{ fontSize: "8px" }}>
											{order.status}
										</Typography>
									</Box>
								</Box>
								<ArrowForwardIosOutlined
									sx={{ fontSize: "8px", marginTop: 1 }}
								/>
							</Box>
							<Divider sx={{ marginTop: 0.5, marginBottom: 0 }} />
						</Grid>
					))}
				{order.value === "order2" &&
					orders.map((order, index) => (
						<Grid item xs={12} key={index}>
							<Box
								sx={{
									display: "flex",
									justifyContent: "space-between",
									alignItems: "flex-start",
								}}
							>
								<Box sx={{ display: "flex", gap: 1 }}>
									<img
										src={order.image}
										alt={order.title}
										style={{ width: 70, height: 100, objectFit: "cover" }}
									/>
									<Box>
										<Typography
											variant="body1"
											sx={{ fontWeight: "bold", fontSize: "8px" }}
										>
											{order.id}
										</Typography>
										<Typography variant="body2" sx={{ fontSize: "8px" }}>
											{order.total} |{" "}
											<span style={{ opacity: 0.6 }}>
												{order.productsCount} products
											</span>
										</Typography>
										<Typography variant="body2" sx={{ fontSize: "8px" }}>
											{order.date}
										</Typography>
										<Typography variant="body2" sx={{ fontSize: "8px" }}>
											{order.status}
										</Typography>
									</Box>
								</Box>
								<ArrowForwardIosOutlined
									sx={{ fontSize: "8px", marginTop: 1 }}
								/>
							</Box>
							<Divider sx={{ marginTop: 1, marginBottom: 0 }} />
						</Grid>
					))}
				{order.value === "order3" &&
					orders.map((order, index) => (
						<Grid item xs={12} key={index}>
							<Box
								sx={{
									display: "flex",
									justifyContent: "space-between",
									alignItems: "flex-start",
								}}
							>
								<Box sx={{ display: "flex", gap: 1 }}>
									<img
										src={order.image}
										alt={order.title}
										style={{
											width: 50,
											height: 50,
											borderRadius: "50%",
											objectFit: "cover",
										}}
									/>
									<Box>
										<Typography
											variant="body1"
											sx={{ fontWeight: "bold", fontSize: "8px" }}
										>
											{order.id}
										</Typography>
										<Typography variant="body2" sx={{ fontSize: "8px" }}>
											{order.total} |{" "}
											<span style={{ opacity: 0.6 }}>
												{order.productsCount} products
											</span>
										</Typography>
										<Typography variant="body2" sx={{ fontSize: "8px" }}>
											{order.date}
										</Typography>
										<Typography variant="body2" sx={{ fontSize: "8px" }}>
											{order.status}
										</Typography>
									</Box>
								</Box>
								<ArrowForwardIosOutlined
									sx={{ fontSize: "8px", marginTop: 1 }}
								/>
							</Box>
							<Divider sx={{ marginTop: 1, marginBottom: 0 }} />
						</Grid>
					))}
				{order.value === "order4" &&
					orders.map((order, index) => (
						<Grid item xs={12} key={index}>
							<Box
								sx={{
									display: "flex",
								}}
							>
								<Box sx={{ display: "flex", gap: 1, flexDirection: "column" }}>
									<img
										src={order.image}
										alt={order.title}
										style={{
											width: "100%",
											height: "auto",
											objectFit: "cover",
										}}
									/>
									<Box
										sx={{
											display: "flex",
											justifyContent: "space-between",
											alignItems: "flex-start",
										}}
									>
										<Box>
											<Typography
												variant="body1"
												sx={{ fontWeight: "bold", fontSize: "8px" }}
											>
												{order.id}
											</Typography>
											<Typography variant="body2" sx={{ fontSize: "8px" }}>
												{order.total} |{" "}
												<span style={{ opacity: 0.6 }}>
													{order.productsCount} products
												</span>
											</Typography>
											<Typography variant="body2" sx={{ fontSize: "8px" }}>
												{order.date}
											</Typography>
											<Typography variant="body2" sx={{ fontSize: "8px" }}>
												{order.status}
											</Typography>
										</Box>
										<ArrowForwardIosOutlined
											sx={{ fontSize: "8px", marginTop: 0.4 }}
										/>
									</Box>
								</Box>
							</Box>
							<Divider sx={{ marginTop: 0.5, marginBottom: 0 }} />
						</Grid>
					))}
			</Grid>
		</Box>
	);
};

export default ShowcaseOrders;
